import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminSettings = () => {
  const [goldRateIQD, setGoldRateIQD] = useState('');
  const [usdToIqdRate, setUsdToIqdRate] = useState('');

  // ✅ new toggles
  const [liveGoldEnabled, setLiveGoldEnabled] = useState(true);
  const [autoUpdateEnabled, setAutoUpdateEnabled] = useState(true);

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get('/api/settings');
        setGoldRateIQD(res.data.goldRateIQD);
        setUsdToIqdRate(res.data.usdToIqdRate);

        // ✅ load toggles
        setLiveGoldEnabled(res.data.liveGoldEnabled !== false);
        setAutoUpdateEnabled(res.data.autoUpdateEnabled !== false);
      } catch (err) {
        console.error('Error loading settings:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/api/settings/update', {
        goldRateIQD,
        usdToIqdRate,
        liveGoldEnabled,
        autoUpdateEnabled,
      });
      setMessage('Settings updated successfully!');
    } catch (err) {
      console.error('Error updating settings:', err);
      setMessage('Failed to update settings.');
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Admin Settings</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <form onSubmit={handleUpdate} className="space-y-4">

          {/* ✅ Live Gold Calculation ON/OFF */}
          <div className="border rounded p-3">
            <label className="block font-semibold mb-2">Live Gold Calculation</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="liveGoldEnabled"
                  checked={liveGoldEnabled === true}
                  onChange={() => setLiveGoldEnabled(true)}
                />
                ON
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="liveGoldEnabled"
                  checked={liveGoldEnabled === false}
                  onChange={() => setLiveGoldEnabled(false)}
                />
                OFF
              </label>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              OFF = backend stops calling Nano/Sheets (no external requests).
            </p>
          </div>

          {/* ✅ Auto Updater ON/OFF */}
          <div className="border rounded p-3">
            <label className="block font-semibold mb-2">Automatic Updater</label>
            <div className="flex gap-6">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="autoUpdateEnabled"
                  checked={autoUpdateEnabled === true}
                  onChange={() => setAutoUpdateEnabled(true)}
                />
                ON
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="autoUpdateEnabled"
                  checked={autoUpdateEnabled === false}
                  onChange={() => setAutoUpdateEnabled(false)}
                />
                OFF
              </label>
            </div>
            <p className="text-xs text-gray-500 mt-2">
              OFF = DB goldRateIQD/USD rate won’t update automatically (manual Save still works).
            </p>
          </div>

          <div>
            <label className="block font-medium">Gold Rate (IQD per gram)</label>
            <input
              type="number"
              value={goldRateIQD}
              onChange={(e) => setGoldRateIQD(e.target.value)}
              className="border rounded w-full p-2"
              required
            />
          </div>

          <div>
            <label className="block font-medium">USD to IQD Rate</label>
            <input
              type="number"
              value={usdToIqdRate}
              onChange={(e) => setUsdToIqdRate(e.target.value)}
              className="border rounded w-full p-2"
              required
            />
          </div>

          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Save Settings
          </button>

          {message && <p className="text-green-600 mt-2">{message}</p>}
        </form>
      )}
    </div>
  );
};

export default AdminSettings;
